import { IProduct } from 'app/shared/model/product.model';
import { ITariff } from 'app/shared/model/tariff.model';

export interface IProductTariffOverride {
  id?: number;
  price?: number | null;
  product?: IProduct | null;
  tariff?: ITariff | null;
}

export const defaultValue: Readonly<IProductTariffOverride> = {};
